import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { billingAtom } from "../../../../../atoms/BillingAtom";
import { UserAtom } from "../../../../../atoms/UserAtom";
import StyledButton from "../../../../StyledButton";
import StyledCheckBox from "../../../../StyledCheckBox";
import { useModal } from "../../../Modal";
import AddressInfoForm from "../AddressInfoForm";
import TermsAndServices from "../TermsAndServices";
import {
  AddressDescription,
  AddressEditButton,
  AddressTitleContainer,
  BillingAddressContainer,
  BillingContainer,
  CardAdsItems,
  CreditCardContainerInfo,
  CreditCardDetails,
  InputPayment,
  InputPaymentContainer,
  PaymentFieldName,
  Row,
  SameAddress,
  SectionTitle,
  ShippingAddressContainer,
  ShippingButtons,
  ShippingContainer,
  ShippingTitle,
  SplitRow,
} from "./PaymentModalStyles";

export default function CreditCardRight(): JSX.Element {
  const userInfo = useRecoilValue(UserAtom);
  const [billing, setBilling] = useRecoilState(billingAtom);

  const modal = useModal();
  const [activeUser, setActiveUser] = useState(false);
  const [loading, setLoading] = useState(false);

  const [billingErrors, setBillingErrors] = useState<boolean>(false);
  const [isBillingEdit, setisBillingEdit] = useState<boolean>(false);
  const [isFirstEditShippingAddress, setisFirstEditShippingAddress] =
    useState<boolean>(false);

  const [, setCustomerID] = useState<string>();
  const [, setSubscriptionId] = useState<string>();

  function checkBilling() {
    let valid = true;

    Object.entries(billing.billingAddress).map((item) => {
      const [key, value] = item;
      if (!value) {
        setBilling((prevState) => ({
          ...prevState,
          errors: {
            ...prevState.errors,
            billingAddress: {
              ...prevState.errors.billingAddress,
              [key]: true,
            },
          },
        }));
        valid = false;
      } else {
        setBilling((prevState) => ({
          ...prevState,
          errors: {
            ...prevState.errors,
            billingAddress: {
              ...prevState.errors.billingAddress,
              [key]: false,
            },
          },
        }));
      }
    });
    return valid;
  }

  // useEffect(() => {
  //   (async () => {
  //     if (!userInfo) return;

  //     const requestBillingInfo = await getBillingInfo({
  //       userUid: userInfo.uid,
  //     });

  //     if (!requestBillingInfo) return;
  //     const {
  //       active,
  //       billingInfo,
  //       stripeCustomerId,
  //       subscriptionId,
  //     } = requestBillingInfo;

  //     setActiveUser(active);
  //     if (billingInfo) {
  //       setBilling((prevState) => ({
  //         ...prevState,
  //         billingAddress: billingInfo.billing_address,
  //         shippingAddress: billingInfo.shipping_address,
  //         customerId: stripeCustomerId as string,
  //         maxAdmins: requestBillingInfo.maxAdmins,
  //         oldMaxAdmins: requestBillingInfo.maxAdmins || 0,
  //         subscriptionEndDate: requestBillingInfo.periodEnd,
  //         vatId: requestBillingInfo.vatId,
  //       }));
  //     }

  //     setCustomerID(stripeCustomerId);
  //     setSubscriptionId(subscriptionId);
  //   })();
  // }, [userInfo]);

  return (
    <CreditCardContainerInfo>
      <CreditCardDetails>
        <SectionTitle>Credit Card Details</SectionTitle>
        <Row>
          <PaymentFieldName>Name on card</PaymentFieldName>
          <InputPayment
            onChange={(event) =>
              setBilling((prevState) => ({
                ...prevState,
                name: event.target.value,
              }))
            }
            placeholder="Enter full name on card"
            value={billing.name}
            error={billing.errors.name as boolean}
          />
        </Row>
        <Row>
          <PaymentFieldName>Credit Card Number</PaymentFieldName>
          <InputPaymentContainer
            focused={billing.selected.ccNumber}
            error={billing.errors.ccNumber as boolean}
          >
            <CardNumberElement
              onFocus={() => {
                setBilling((prevState) => ({
                  ...prevState,
                  selected: {
                    ccNumber: true,
                    expDate: false,
                    cvc: false,
                  },
                }));
              }}
              onBlur={() => {
                setBilling((prevState) => ({
                  ...prevState,
                  selected: {
                    ccNumber: false,
                    expDate: false,
                    cvc: false,
                  },
                }));
              }}
              options={{
                showIcon: true,
                style: {
                  base: {
                    fontSize: "16px",
                    lineHeight: "46px",
                    padding: "6px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#eb1c26",
                  },
                },
              }}
              onChange={(event) => {
                setBilling((prevState) => ({
                  ...prevState,
                  errors: {
                    ...prevState.errors,
                    ccNumber: !!event.error,
                  },
                }));
              }}
            />
            <CardAdsItems />
          </InputPaymentContainer>
        </Row>
        <SplitRow style={{ paddingBottom: "0" }}>
          <div>
            <PaymentFieldName>Expiration Date</PaymentFieldName>
            <InputPaymentContainer
              focused={billing.selected.expDate}
              error={billing.errors.expDate as boolean}
            >
              <CardExpiryElement
                onFocus={() => {
                  setBilling((prevState) => ({
                    ...prevState,
                    selected: {
                      ccNumber: false,
                      expDate: true,
                      cvc: false,
                    },
                  }));
                }}
                onBlur={() => {
                  setBilling((prevState) => ({
                    ...prevState,
                    selected: {
                      ccNumber: false,
                      expDate: false,
                      cvc: false,
                    },
                  }));
                }}
                options={{
                  style: {
                    base: {
                      fontSize: "16px",
                      lineHeight: "46px",
                      padding: "6px",
                      color: "#424770",
                      "::placeholder": {
                        color: "#aab7c4",
                      },
                    },
                    invalid: {
                      color: "#eb1c26",
                    },
                  },
                }}
                onChange={(event) =>
                  setBilling((prevState) => ({
                    ...prevState,
                    errors: {
                      ...prevState.errors,
                      expDate: !!event.error,
                    },
                  }))
                }
              />
            </InputPaymentContainer>
          </div>
          <div>
            <PaymentFieldName>CVC</PaymentFieldName>
            <InputPaymentContainer
              focused={billing.selected.cvc}
              error={billing.errors.cvc as boolean}
            >
              <CardCvcElement
                onFocus={() => {
                  setBilling((prevState) => ({
                    ...prevState,
                    selected: {
                      ccNumber: false,
                      expDate: false,
                      cvc: true,
                    },
                  }));
                }}
                onBlur={() => {
                  setBilling((prevState) => ({
                    ...prevState,
                    selected: {
                      ccNumber: false,
                      expDate: false,
                      cvc: false,
                    },
                  }));
                }}
                options={{
                  style: {
                    base: {
                      fontSize: "16px",
                      lineHeight: "46px",
                      padding: "6px",
                      color: "#424770",
                      "::placeholder": {
                        color: "#aab7c4",
                      },
                    },
                    invalid: {
                      color: "#eb1c26",
                    },
                  },
                }}
                onChange={(event) => {
                  setBilling((prevState) => ({
                    ...prevState,
                    errors: {
                      ...prevState.errors,
                      cvc: !!event.error,
                    },
                  }));
                }}
              />
            </InputPaymentContainer>
          </div>
        </SplitRow>
      </CreditCardDetails>

      <BillingContainer>
        <SectionTitle>Billing Address</SectionTitle>
        {!isBillingEdit ? (
          <AddressInfoForm
            setAddress={(billingAddress) => {
              setBilling((prevState) => ({ ...prevState, billingAddress }));
            }}
            address={billing.billingAddress}
            errors={billing.errors.billingAddress}
          />
        ) : (
          <BillingAddressContainer>
            <AddressTitleContainer>
              <AddressDescription>
                {billing.billingAddress.street}, {billing.billingAddress.city}{" "}
                {billing.billingAddress.state_region}{" "}
                {billing.billingAddress.zip_code},{" "}
                {billing.billingAddress.country}
              </AddressDescription>
            </AddressTitleContainer>
            <AddressEditButton
              onClick={() => {
                setisBillingEdit(false);
                setBilling((prevState) => ({
                  ...prevState,
                  termsAndConditions: false,
                  shippingAddress: {
                    street: "",
                    state_region: "",
                    zip_code: "",
                    country: "",
                    city: "",
                  },
                }));
              }}
            >
              Edit
            </AddressEditButton>
          </BillingAddressContainer>
        )}
      </BillingContainer>

      <SameAddress
        style={{
          cursor: "pointer",
        }}
        onClick={() => {
          if (checkBilling() && billing.termsAndConditions === false) {
            modal.pushModal(
              <TermsAndServices
                onOkClick={() => {
                  setBilling((prevState) => ({
                    ...prevState,
                    termsAndConditions: true,
                  }));
                  setisBillingEdit(true);
                  setBillingErrors(false);
                  modal.popModal();
                }}
              />
            );
          } else {
            setisBillingEdit(false);
            setBilling((prevState) => ({
              ...prevState,
              termsAndConditions: false,
            }));
            setBillingErrors(true);
          }
        }}
      >
        <StyledCheckBox
          check={billing.termsAndConditions}
          handleCheck={() => {
            if (checkBilling() && billing.termsAndConditions === false) {
              modal.pushModal(
                <TermsAndServices
                  onOkClick={() => {
                    setBilling((prevState) => ({
                      ...prevState,
                      termsAndConditions: true,
                    }));
                    setisBillingEdit(true);
                    setBillingErrors(false);
                    modal.popModal();
                  }}
                />
              );
            } else {
              setisBillingEdit(false);
              setBilling((prevState) => ({
                ...prevState,
                termsAndConditions: false,
              }));
              setBillingErrors(true);
            }
          }}
          customCss={{
            cursor: "pointer",
          }}
          // color="#72c02a"
          // colorHover="#5fa200"
        />
        <div
          style={{
            font: "normal normal bold 16px Lato",
            marginLeft: "15px",
          }}
        >
          I agree to the terms and conditions
          {billingErrors && (
            <span style={{ color: "#eb1c26", fontSize: "12px" }}>
              <br />
              Check your billing information
            </span>
          )}
        </div>
      </SameAddress>

      {billing.termsAndConditions && (
        <ShippingContainer>
          <ShippingTitle>Shipping Address</ShippingTitle>
          <div
            style={{
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            Why do we need it? We sometimes ship you goodies!
            {billing.customShipping && (
              <AddressEditButton
                onClick={() =>
                  setBilling((prevState) => ({
                    ...prevState,
                    customShipping: false,
                  }))
                }
              >
                Cancel
              </AddressEditButton>
            )}
          </div>

          {billing.customShipping ? (
            <>
              <AddressInfoForm
                setAddress={(shippingAddress) => {
                  setBilling((prevState) => ({
                    ...prevState,
                    shippingAddress,
                  }));
                }}
                address={billing.shippingAddress}
                errors={
                  billing.errors.shippingAddress as {
                    street: boolean;
                    state_region: boolean;
                    zip_code: boolean;
                    country: boolean;
                    city: boolean;
                  }
                }
              />
            </>
          ) : (
            <ShippingAddressContainer
              isFirstEditShippingAddress={isFirstEditShippingAddress}
            >
              <AddressTitleContainer>
                <AddressDescription>
                  {billing.billingAddress.street}, {billing.billingAddress.city}{" "}
                  {billing.billingAddress.state_region}{" "}
                  {billing.billingAddress.zip_code},{" "}
                  {billing.billingAddress.country}
                </AddressDescription>
              </AddressTitleContainer>
              {isFirstEditShippingAddress && (
                <AddressEditButton
                  onClick={() => {
                    setBilling((prevState) => ({
                      ...prevState,
                      customShipping: true,
                      shippingAddress: billing.billingAddress,
                    }));
                  }}
                >
                  Edit
                </AddressEditButton>
              )}
              {!isFirstEditShippingAddress && (
                <ShippingButtons>
                  <StyledButton
                    onClick={(e) => {
                      e.preventDefault();
                      setBilling((prevState) => ({
                        ...prevState,
                        customShipping: true,
                        shippingAddress: billing.billingAddress,
                      }));
                      setisFirstEditShippingAddress(true);
                    }}
                  >
                    Edit address
                  </StyledButton>
                  <StyledButton
                    // css={css`
                    //   width: 150px;
                    // `}
                    inverted
                    onClick={(e) => {
                      e.preventDefault();
                      setisFirstEditShippingAddress(true);
                    }}
                  >
                    Use this address
                  </StyledButton>
                </ShippingButtons>
              )}
            </ShippingAddressContainer>
          )}
        </ShippingContainer>
      )}
      <ShippingContainer style={{ border: "none" }}>
        <ShippingTitle>
          Additional Information
          <span
            style={{
              color: "#707070",
              fontWeight: "normal",
            }}
          >
            (Optional)
          </span>
        </ShippingTitle>
        <br />
        <PaymentFieldName>Company Name</PaymentFieldName>
        <InputPayment
          onChange={(event) => {
            event.preventDefault();
            setBilling((prevState) => ({
              ...prevState,
              companyName: event.target.value,
            }));
          }}
          placeholder="Enter company name"
          value={billing.companyName || ""}
          error={false}
        />
        <br />
        <br />
        <PaymentFieldName>VAT ID</PaymentFieldName>
        <InputPayment
          onChange={(event) => {
            event.preventDefault();
            setBilling((prevState) => ({
              ...prevState,
              vatId: event.target.value,
            }));
          }}
          placeholder="VAT ID"
          value={billing.vatId || ""}
          error={false}
        />
      </ShippingContainer>
    </CreditCardContainerInfo>
  );
}
